import React from 'react'
import { css } from '@emotion/core'
import { Checkbox, CheckboxProps } from '@/components/atoms/checkbox'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

export const FrontTabletCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      style={css(
        {
          img: { width: FrontTabletFontSize.radio, height: FrontTabletFontSize.radio, marginRight: 0 },
          p: {
            marginLeft: 16,
            fontSize: FrontTabletFontSize.radioLabel,
            letterSpacing: 1.3,
            color: '#272727',
          },
        },
        createSelfCheckinResponsiveStyle({
          landscape13: { p: { fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13 } },
        }),
      )}
    />
  )
}
